import { type TFunction } from "i18next";
import { z } from "zod";

export const MAX_TEXT_LENGTH = 1000;

export const resumeInterruptionSchema = (t: TFunction) =>
  z.object({
    resolutionDetails: z
      .string()
      .max(
        1000,
        t("form-validation.max-length", {
          label: t("vessel-call.common.external-notes"),
          max: 1000,
        }),
      )
      .min(
        1,
        t("form-validation.mandatory", { label: t("vessel-call.resume.resolution-details") }),
      ),

    internalAttachments: z.any().optional(),
  });

export type resumeInterruptionSchema = z.infer<ReturnType<typeof resumeInterruptionSchema>>;
